declare global {
  interface Window {
    gtag: any;
  }
}

export default class GoogleAnalyticsEvents {
  static switchStepEvent(eventNumber: number) {
    switch (eventNumber) {
      case 1:
        return GoogleAnalyticsEvents.callStepOne();
      case 2:
        return GoogleAnalyticsEvents.callStepTwo();
      case 3:
        return GoogleAnalyticsEvents.callStepThree();
      case 4:
        return GoogleAnalyticsEvents.callStepFour();
      case 5:
        return GoogleAnalyticsEvents.callStepFive();
      case 6:
        return GoogleAnalyticsEvents.callStepSix();
      case 7:
        return GoogleAnalyticsEvents.callStepSeven();
      default:
        return false;
    }
  }

  static initRegisterTest() {
    window.gtag('event', 'initRegisterTest', { method: 'Google' });
  }

  static callStepOne() {
    window.gtag('event', 'callStepOne', { method: 'Google' });
  }

  static callStepTwo() {
    window.gtag('event', 'callStepTwo', { method: 'Google' });
  }

  static callStepThree() {
    window.gtag('event', 'callStepThree', { method: 'Google' });
  }

  static callStepFour() {
    window.gtag('event', 'callStepFour', { method: 'Google' });
  }

  static callStepFive() {
    window.gtag('event', 'callStepFive', { method: 'Google' });
  }

  static callStepSix() {
    window.gtag('event', 'callStepSix', { method: 'Google' });
  }

  static callStepSeven() {
    window.gtag('event', 'callStepSeven', { method: 'Google' });
  }

  static callJumpCounter() {
    window.gtag('event', 'callJumpCounter', { method: 'Google' });
  }

  static generateCardResult() {
    window.gtag('event', 'generateCardResult', { method: 'Google' });
  }

  static SharedByWhatsapp() {
    window.gtag('event', 'SharedByWhatsapp', { method: 'Google' });
  }

  static callTelemedicina() {
    window.gtag('event', 'callTelemedicina', { method: 'Google' });
  }

  static CallMarketplace() {
    window.gtag('event', 'CallMarketplace', { method: 'Google' });
  }

  static clickInfoMyResult() {
    window.gtag('event', 'clickInfoMyResult', { method: 'Google' });
  }

  static clickNetflixLink() {
    window.gtag('event', 'clickNetflixLink', { method: 'Google' });
  }

  static firstSlideDrag() {
    window.gtag('event', 'firstSlideDrag', { method: 'Google' });
  }

  static clickPlayVideo() {
    window.gtag('event', 'clickPlayVideo', { method: 'Google' });
  }
}
